import { SxProps } from '@mui/material';
import { SummaryPriceLineData } from './summary-mapping';
import { SummaryPriceLine } from './SummaryPriceLine';

export function SummaryPriceLines({
    invertedColorsClass,
    lines,
}: {
    invertedColorsClass?: SxProps;
    lines: SummaryPriceLineData[];
}) {
    return (
        <>
            {lines.map((line, i) => {
                return (
                    <SummaryPriceLine
                        key={i}
                        data={line}
                        typographySx={invertedColorsClass}
                    ></SummaryPriceLine>
                );
            })}
        </>
    );
}
